@import "src/styles/common/_colors.scss";
.digitalInspectionWrapper {
  gap: 1rem;
  display: flex;
  padding: 0.625rem 0;
  height: 100%;
  .radioButtonGroup {
    gap: 0;
    margin-left: -0.5rem;
  }
  .reportListWrapper {
    height: 100%;
    .reportPanel {
      height: calc(100% - 20px);
      .panelList {
        background: $gray;
        height: 98%;
        overflow-y: visible !important;
        display: flex;
        flex-direction: column;
        border: 1px solid $black;
        .emptyMessage {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
        }
        .panelListInner {
          height: 100%;
          position: relative;
          .reportListHeader {
            border-bottom: 1px solid $orientation-icon-color;
            display: flex;
            gap: 0.25rem;
            height: 30px;
            align-items: center;
            padding: 0.5rem;
            &.noBorder {
              border-bottom: none;
            }
          }
          .reportListBody {
            width: 100%;
            max-height: calc(100% - 30px);
            overflow-y: scroll;
            position: absolute;
            min-height: 200px;
            .propertiesLabel {
              display: flex;
              gap: 0.5rem;
            }
            .editableSectionData {
              margin-left: 2rem;
              display: flex;
              gap: 0.5rem;
            }
            .infoBlock {
              color: $blue;
              cursor: pointer;
            }
          }
          .reportListBodyLoading {
            height: 100%;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
  .yellowText {
    color: $yellow;
  }
  .searchHighlight {
    background-color: $text-highlight;
    color: $white;
  }
}